import InfoIcon from '@mui/icons-material/Info';
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import { Tooltip } from '@mui/material';

function InfoTooltipIcon({title="", outlined=false, sx={}}:{title:string, outlined?: boolean, sx?: object}) {
  return (<Tooltip title={title} sx={{mx:'2px',verticalAlign:'baseline',fontSize:12,cursor:'pointer', ...sx}} enterTouchDelay={0}>{outlined ? <InfoOutlined/> : <InfoIcon/>}</Tooltip>
  );
}
export default InfoTooltipIcon;